import { render, staticRenderFns } from "./ProjectCreateBanner.vue?vue&type=template&id=4cf7bf9b&lang=pug&"
import script from "./ProjectCreateBanner.vue?vue&type=script&lang=js&"
export * from "./ProjectCreateBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreateBanner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports